import styled from 'styled-components'
import PropTypes from 'prop-types'
import { t } from 'ttag'
import { Link } from 'react-router-dom'
import { useContext } from 'react'

import { PB97T, PB90T, WHITE } from '@h2/components/colors'
import { Flex } from '@h2/components/layout/flex'
import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import { ImportIcon } from '@h2/components/icons/import'
import { InviteUsersIcon } from '@h2/components/icons/inviteUsers'
import { Globals } from '@h2/globals'

import { Dropdown } from '../dropdown'

const Wrap = styled.div`
  flex-grow: 1;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : '')};
  background-color: ${PB97T};
  padding: 20px;
  border-radius: 5px;

  & strong {
    font-weight: 400;
  }
`
const StyledLink = styled(Link)`
  &:link,
  &:active,
  &:visited {
    background-color: ${WHITE};
    border: solid ${PB90T} 1px;
    border-radius: 5px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    padding: 6px 10px;
    margin: 0 0 0 5px;
    * {
      cursor: pointer;
    }
  }

  &:hover {
    background-color: ${PB97T};
  }
`
const renderIcon = ({ icon: Icon }) => (Icon ? <Icon size="medium" /> : null)
const Overview = ({
  fullWidth = false,
  icon = null,
  title = '',
  dropdown = { text: '', items: [] },
  importUsers = false,
  inviteUsers = false,
  children
}) => {
  const { isSubscriber } = useContext(Globals)

  return (
    <Wrap fullWidth={fullWidth}>
      <Flex alignItems="center" wrap="wrap">
        {renderIcon({ icon })}
        <Heading level="4" mb="0" ml="7.5px" weight="light">
          <strong>{title}</strong> Overview
        </Heading>
        <Flex margin="5px 0 0 auto">
          {importUsers && isSubscriber && (
            <StyledLink to="/management/users/importer">
              <ImportIcon size="tiny" />
              <Text size="medium" weight="bold" margin="0 0 0 5px">
                {t`Import Users`}
              </Text>
            </StyledLink>
          )}
          {inviteUsers && isSubscriber && (
            <StyledLink to="/admin/users/invite">
              <InviteUsersIcon size="tiny" />
              <Text size="medium" weight="bold" margin="0 0 0 5px">
                {t`Invite Users`}
              </Text>
            </StyledLink>
          )}
          <Dropdown margin="0 0 0 5px">
            <Dropdown.Text>{dropdown.text}</Dropdown.Text>
            {dropdown.items
              .filter(
                item =>
                  (!item.subscriberOnly || isSubscriber === item.subscriberOnly) &&
                  !item.disabled
              )
              .map((item, index) => (
                <Dropdown.Item icon={item.icon} key={index} href={item.href}>
                  {item.text}
                </Dropdown.Item>
              ))}
          </Dropdown>
        </Flex>
      </Flex>
      {children}
    </Wrap>
  )
}

Overview.propTypes = {
  fullWidth: PropTypes.bool,
  icon: PropTypes.elementType,
  title: PropTypes.string,
  inviteUsers: PropTypes.bool,
  importUsers: PropTypes.bool,
  dropdown: PropTypes.shape({
    text: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.elementType,
        text: PropTypes.string,
        href: PropTypes.string
      })
    )
  })
}

export { Overview }
